import React from 'react';

export const LaborSafetySearchForm = props => (
  <div className='gate-schedulelist__searchform'>
    <div className='search-form'>
      <div className='search-form__header'>
        <div className='search-form__title'>
          検索条件（検索結果<span className='bold'>{props.total}</span>件)
        </div>
        <button
          id='accordion-toggle'
          className={props.isOpen ? 'accordion__btn show' : 'accordion__btn'}
          onClick={props.onOpen}
        />
        <button
          className='btn-text--sm'
          onClick={() => props.callbacks.searchform.clear()}
        >
          検索条件クリア
        </button>
      </div>
      <div
        id='search-form-accordion'
        className={props.isOpen ? 'accordion show' : 'accordion'}
      >
        <div className='search-form__body'>
          <div className='form form--search-form'>
            <div className='form__group flex-wrap'>{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/searchmenus/LaborSafety.jsx